// AI-CONTEXT: See docs/features/update-aanvragen.md

import { isOpenUpdateRequestStatus } from './updateRequestStatus'

/**
 * Aantal nog openstaande updateverzoeken per organisatie.
 *
 * Openstaand = 'nieuw' of 'in behandeling'. Een status die niet klopt telt niet
 * mee: dat is dataschade, en meetellen blaast het getal op de Overzicht-kaart
 * op zonder dat iemand ziet waardoor. Het verzoek zelf blijft wel in de lijsten
 * staan, dus het raakt niet zoek.
 *
 * Een organisatie zonder openstaande verzoeken komt niet in de uitkomst voor.
 * De kaart bepaalt zelf of dat een streepje of een nul wordt.
 *
 * @param {Array<{CompagnyID?: string, Status?: string}>|null|undefined} requests
 * @returns {Map<string, number>} CompagnyID → aantal openstaande verzoeken
 */
const countOpenRequestsByTenant = (requests) => {
    const counts = new Map()

    if (!Array.isArray(requests)) return counts

    requests.forEach((request) => {
        const compagnyId = request?.CompagnyID
        if (!compagnyId || !isOpenUpdateRequestStatus(request?.Status)) return

        counts.set(compagnyId, (counts.get(compagnyId) || 0) + 1)
    })

    return counts
}

export default countOpenRequestsByTenant
